import React, {Fragment} from 'react';
import useHeaders from './useHeaders';
import useCells from './useCells';
import utils from "../../../utils";
import MyTable from "../../../components/Shared/MyTable";
import CenterLoading from "../../../components/CenterLoading";
import {useCaseList} from "../../../queries/case";
import usePage from "../../../hooks/usePage";
import {route_path} from "../CaseList_Route";

const CaseList = () => {
    const page = usePage();
    const cells = useCells();
    const headers = useHeaders();
    const {isLoading, data} = useCaseList();

    if(isLoading){
        return <Fragment />
    }

    const {records=[], total_count: totalCount} = data.data;
    if(isLoading){
        return <CenterLoading />
    }
    else{
        return <MyTable
            headers={headers}
            cells={cells}
            records={records.sort(utils.compareByPriority)}
            totalCount={totalCount}
            onPageChange={value=>{
                if(value !== page){
                    utils.changeParams({route_path, property: "page", type: "Number", value, filters: utils.get_filters()});
                }
            }}
        />
    }
}

CaseList.defaultProps = {
};

CaseList.propTypes = {
};

export default CaseList;
